import {
  DownloadStatus,
  ErrorStatus,
  InstallStatus,
  NewStatus,
  ReadyStatus,
  RebootStatus,
  SuccessStatus,
} from 'components/Statuses'

import type { HomeCloudSoftwareHistoryType } from 'features/home/types'
import { SoftwareUpdateStatusContainer } from './styles'

type USoftwareUpdateStatusProps = Pick<
  HomeCloudSoftwareHistoryType,
  'state' | 'message' | 'progress'
>
type ValidStates = Exclude<HomeCloudSoftwareHistoryType['state'], undefined>
type StatusHash = { [P in ValidStates]: (props: any) => JSX.Element }

const statusHash: StatusHash = {
  ERROR: ErrorStatus,
  INSTALL: InstallStatus,
  NEW: NewStatus,
  REBOOT: RebootStatus,
  SUCCESS: SuccessStatus,
  DOWNLOAD: DownloadStatus,
  READY: ReadyStatus,
}

function SoftwareUpdateStatus(props: USoftwareUpdateStatusProps) {
  const { state, message, progress } = props

  if (!state) {
    return null
  }

  const StatusComponent = statusHash[state] || statusHash.ERROR

  return (
    <SoftwareUpdateStatusContainer>
      <StatusComponent message={message} progress={progress} />
    </SoftwareUpdateStatusContainer>
  )
}

export default SoftwareUpdateStatus
